import './ArticleBox.less';

import clsx from 'clsx';
import React from 'react';

import { navigate } from '@/routing';
import ArrowIcon from 'nike-ui/src/icons/svg/arrow-icon-sv.svg';
import { fireGAEvent } from '@/analytics';

function ArticleBox({ route, title, articleUrl, className, event }) {
    return (
        <div
            data-atid={articleUrl}
            className={clsx('article-box', className)}
            onClick={() => {
                navigate(route, { articleUrl: articleUrl });
                if (event) {
                    fireGAEvent(event.category, event.action);
                }
            }}
        >
            <span className="title">{title}</span>
            <span>{<ArrowIcon />}</span>
        </div>
    );
}

export default ArticleBox;
